import { BillingRunStatus } from "constants/billingRuns";

import { createLookupCombiner, createLookupSelectors } from "./lib";
import { getBillingRuns } from "./root";

export const getBillingRunById = billingRunId => state =>
  getBillingRuns(state)[billingRunId] || null;

export const getActiveBillingRunId = state =>
  state.billingRuns.activeBillingRunId;

export const [selectIsReadOnlyByBillingRunId, getIsReadOnlyByBillingRunId] =
  createLookupSelectors(
    [getBillingRuns],
    createLookupCombiner(
      billingRun => billingRun.status === BillingRunStatus.FINISHED,
    ),
  );
